import { BodyMedium, BodySmall, FormRadioInput, theme } from '@arnold/common';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SurveyGroupRespondentImportType, SurveyQuery } from '../../generated/hooks';
import { ExplanatoryList, WarningText } from '../StyledComponents';

type Respondent = Pick<
  NonNullable<SurveyQuery['survey']>['whitelistedRespondents'][0],
  'id' | 'firstname' | 'surname'
> & {
  type?: SurveyGroupRespondentImportType;
};

type SurveyGroupChooseInstanceTypeProps = {
  respondent: Respondent;
  disableNewRun?: boolean;
  setRespondentRunType?: (id: string, type: SurveyGroupRespondentImportType) => void;
};

const SurveyGroupChooseInstanceType: FC<SurveyGroupChooseInstanceTypeProps> = ({
  respondent,
  disableNewRun,
  setRespondentRunType,
}) => {
  const { t } = useTranslation('surveyGroupAddParticipants');
  const value = respondent.type ?? SurveyGroupRespondentImportType.CreateNewRun;
  return (
    <div className="mt-5">
      <FormRadioInput
        name={`runType-${respondent.id}`}
        value={SurveyGroupRespondentImportType.ChangeDate}
        clicked={() => {
          if (setRespondentRunType) {
            setRespondentRunType(respondent.id, SurveyGroupRespondentImportType.ChangeDate);
          }
        }}
        changed={() => {
          if (setRespondentRunType) {
            setRespondentRunType(respondent.id, SurveyGroupRespondentImportType.ChangeDate);
          }
        }}
        defaultChecked={value === SurveyGroupRespondentImportType.ChangeDate}
        label={t('replan')}
      />
      <ExplanatoryList>
        <li>
          <BodySmall>{t('replanInfo1')}</BodySmall>
        </li>
        <li>
          <BodySmall>{t('replanInfo2')}</BodySmall>
        </li>
        <li>
          <BodySmall>{t('replanInfo3')}</BodySmall>
        </li>
      </ExplanatoryList>
      <FormRadioInput
        name={`runType-${respondent.id}`}
        value={SurveyGroupRespondentImportType.CreateNewRun}
        disabled={disableNewRun}
        clicked={() => {
          if (setRespondentRunType) {
            setRespondentRunType(respondent.id, SurveyGroupRespondentImportType.CreateNewRun);
          }
        }}
        changed={() => {
          if (setRespondentRunType) {
            setRespondentRunType(respondent.id, SurveyGroupRespondentImportType.CreateNewRun);
          }
        }}
        defaultChecked={value === SurveyGroupRespondentImportType.CreateNewRun}
        label={t('newRun')}
      />
      <ExplanatoryList>
        <li>
          <BodySmall>{t('newRunInfo1')}</BodySmall>
        </li>
        <li>
          <BodySmall>{t('newRunInfo2')}</BodySmall>
        </li>
        <li>
          <BodySmall>{t('newRunInfo3')}</BodySmall>
        </li>
      </ExplanatoryList>
      {disableNewRun && (
        <BodyMedium margin={`0 0 0 ${theme.spacing.f}`}>
          <WarningText>{t('teamioOnb:usageExceededForSelect')}</WarningText>
        </BodyMedium>
      )}
    </div>
  );
};

export default SurveyGroupChooseInstanceType;
